import { isPostcode, Nullable, Postcode } from '@lovejunk/core'
import { isNull } from 'lodash'

export const isPostcodeValid = (postcode: Nullable<Postcode>): postcode is Postcode =>
  !isNull(postcode) && isPostcode(postcode)
